<template>
  <ValidationProvider
    v-slot="{ errors, valid, handleChange, handleBlur }"
    :vid="(group != '' ? group + '_' : '') + vid"
    :name="name || entryInputControl"
    :rules="`${rules}|${entryInputType === 'is-danger' && !disabled ? 'required' : ''}`"
    :model-value="innerValue"
    class="CheckBoxEntryInput-provider"
    @update:model-value="updateValue"
  >
    <b-field
      :type="{
        'is-normal': disabled,
        'is-danger': errors[0],
        'is-success': valid,
      }"
      class="CheckBoxEntryInput-field"
    >
      <div :class="`CheckBoxEntryInput-control-container`">
        <b-input
          v-model="innerValue"
          :placeholder="entryInputPlaceholder"
          :disabled="disabled"
          @update:model-value="
            (val: any) => {
              handleChange && handleChange(val)
              onInputChange()
            }
          "
          @blur="(event: any) => handleBlur && handleBlur(event)"
        ></b-input>
        <p v-if="entryInputControl" class="CheckBoxEntryInput-control">
          <span class="button is-static">{{ entryInputControl }}</span>
        </p>
      </div>
    </b-field>
    <p v-if="errors.length > 0" class="help is-danger">
      {{ errors[0] }}
    </p>
  </ValidationProvider>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import ValidationProvider from "@/services/validation/ValidationProvider.vue"

export default defineComponent({
  name: "CheckBoxEntryInput",
  components: { ValidationProvider },
  props: {
    vid: {
      type: String,
      default: "",
    },
    group: {
      type: String,
      default: "",
    },
    entryInputControl: {
      type: String,
      default: "",
    },
    entryInputPlaceholder: {
      type: String,
      default: "",
    },
    entryInputValue: {
      type: [String, Number],
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Array],
      default: "",
    },
    resetInput: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue"],
  data() {
    return {
      entryInputType: "",
      innerValue: "" as string | number,
    }
  },
  watch: {
    disabled(): void {
      this.setEntryInputType()
    },
    resetInput(): void {
      if (!this.resetInput) {
        return
      }

      this.innerValue = ""
      this.$emit("update:modelValue", this.innerValue)
    },
  },
  created(): void {
    if (this.entryInputValue !== "" && this.entryInputValue != null) {
      this.innerValue = this.entryInputValue
    }
    this.setEntryInputType()
  },
  methods: {
    onInputChange(): void {
      this.setEntryInputType()
      this.$emit("update:modelValue", this.innerValue)
    },

    setEntryInputType(): void {
      if (this.disabled) {
        this.entryInputType = "is-normal"
      } else {
        this.entryInputType =
          this.innerValue !== "" && this.innerValue != null ? "is-success" : "is-danger"
      }
    },

    updateValue(newValue: string): void {
      this.innerValue = newValue
      this.$emit("update:modelValue", newValue)
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.CheckBoxEntryInput-provider {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.CheckBoxEntryInput-field {
  .CheckBoxEntryInput-control {
    min-width: 80px;

    span {
      width: 100%;
    }

    .is-static {
      color: $dark;
    }
  }
}

.CheckBoxEntryInput-control-container {
  display: flex;

  .control {
    width: 100%;
  }
}
</style>
